module.exports = __webpack_public_path__ + "static/media/asteroids.7d8d207f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/asteroids.png
// module id = 141
// module chunks = 0